import { render, staticRenderFns } from "./DSProductIcon.vue?vue&type=template&id=0a8f47a1&scoped=true&"
import script from "./DSProductIcon.vue?vue&type=script&lang=js&"
export * from "./DSProductIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8f47a1",
  null
  
)

export default component.exports